export default __webpack_public_path__ + "static/media/muñecas de barro masaya.9064913b.jpg";